import axios from 'axios';
import { AULA_ASSIGNMENTS } from '../../constants/endpoints';
import { getHeaders } from './utils';

type HomeUpcomingAssignment = {
  id: string;
  title: string;
  dueDate: string | null;
  startDate?: string;
  spaceId: string;
  courseName: string;
  role: 'educator' | 'student';
  status: 'Upcoming' | 'DueSoon' | 'Open';
  isSubmitted: boolean;
  isHidden: boolean;
  cta: { label: string | null; path: string | null; disabled: boolean };
};

export type { HomeUpcomingAssignment };

export type FetchHomeUpcomingAssignmentsResponse = {
  upcomingAssignments: HomeUpcomingAssignment[];
  page: number;
  limit: number;
  total: number;
};

export const fetchHomeUpcomingAssignments = async ({
  accessToken,
  limit = 5,
  page = 0,
  includeSubmitted = true,
}: {
  accessToken: string;
  limit?: number;
  page?: number;
  includeSubmitted?: boolean;
}) =>
  axios.get<FetchHomeUpcomingAssignmentsResponse>(
    `${AULA_ASSIGNMENTS()}/home/upcoming-assignments`,
    {
      params: { limit, page, includeSubmitted: String(includeSubmitted) },
      headers: getHeaders(accessToken),
    }
  );
